import { useToast } from '@chakra-ui/react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import { useContext, useEffect, useRef, useState } from 'react';

const ENDPOINT = process.env.REACT_APP_ENVIRONMENT === 'production' ? process.env.REACT_APP_URL_DEOVITA_PROD : process.env.REACT_APP_URL_DEOVITA_TEST;

const useModelAnexoChamada = (props) => {
  const { user } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errorSubmit, setErrorSubmit] = useState(null);
  const [loading, setLoading] = useState(false);
  const agenda_exames_id = props?.agenda_exames_id;
  const disclosure = props?.disclosure;
  const toast = useToast();

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles((prevFiles) => {
      const fileNames = prevFiles.map((f) => f.name);
      const newFiles = files.filter((f) => !fileNames.includes(f.name));
      return [...prevFiles, ...newFiles];
    });
  };

  const handleExcludeFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  async function handleSubmitFiles() {
    if (selectedFiles.length < 1) {
      setErrorSubmit('Você precisa informar pelo menos um arquivo');
      return;
    }

    try {
      setLoading(true);
      const url = `${ENDPOINT}/deovita/upload/uploadarquivoatendimento/${agenda_exames_id}`;

      let formData = new FormData();
      selectedFiles.forEach((file, index) => {
        formData.append('arquivo_atendimento[]', file);
      });

      await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6ImVsbGluZ3RvbiIsImlhdCI6MTUxNjIzOTAyMiwiaXNfbW9iaWxlIjp0cnVlfQ.Makap5iKf1AddIxftWbAi1GCEC60rzimUmXNpBOAw-E`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          
          setLoading(false);
          //if (data.status === 'success') {
            setErrorSubmit(null);
            setSelectedFiles([]);
            toast({
              title: 'Sucesso!',
              description: 'Seu arquivo foi enviado para o médico',
              status: 'success',
              duration: 4000,
              isClosable: true,
              position: 'bottom',
              colorScheme: 'green',
              containerStyle: {
                paddingTop: '50px',
              },
            });
            disclosure.onClose();
            return
          //}
          //alert(JSON.stringify(data, null, 2))
        })
        .catch((error) => {
          //alert("cath error", JSON.stringify(error, null, 2))
          setLoading(false);
          setErrorSubmit('Não foi possível enviar seu arquivo.');
        });
    } catch (error) {
      //alert("cath error 2", JSON.stringify(error, null, 2))
      setLoading(false);
      setErrorSubmit('Não foi possível enviar seu arquivo.');
      console.log('error ', error);
    }
  }

  return { theme, selectedFiles, handleFileChange, handleExcludeFile, handleSubmitFiles, errorSubmit, loading };
};

export default useModelAnexoChamada;
